'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Components


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _iconsPopupActions = require('./iconsPopupActions');

var _PopupPanel = require('../../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _IconTabContent = require('./tabContent/IconTabContent');

var _IconTabContent2 = _interopRequireDefault(_IconTabContent);

var _IconPopupModeList = require('./modeMenu/IconPopupModeList');

var _IconPopupModeList2 = _interopRequireDefault(_IconPopupModeList);

var _IconPopupSearch = require('./modeMenu/IconPopupSearch');

var _IconPopupSearch2 = _interopRequireDefault(_IconPopupSearch);

var _popupConstants = require('../../../../../components/popupPanel/popupConstants');

var _iconsPopupConstants = require('./iconsPopupConstants');

var _iconPopupSelector = require('./iconPopupSelector');

var _iconPopupSelector2 = _interopRequireDefault(_iconPopupSelector);

require('./IconPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        searchForIcons: function searchForIcons(_ref) {
            var query = _ref.query,
                id = _ref.id;
            return dispatch((0, _iconsPopupActions.findIcons)({ query: query, id: id }));
        },
        setModeDefault: function setModeDefault(event) {
            event.preventDefault();
            dispatch((0, _iconsPopupActions.setIconPopupMode)({ mode: _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT }));
        },
        setMode: function setMode(_ref2) {
            var mode = _ref2.mode,
                id = _ref2.id;

            if (!mode) return;
            dispatch((0, _iconsPopupActions.setIconPopupMode)({ mode: mode, id: id }));
        }
    };
};

var popupModeHasChanged = function popupModeHasChanged(props, nextProps) {
    return nextProps.popupMode !== props.popupMode;
};
var popupModeIsImages = function popupModeIsImages(props) {
    return props.popupMode === _iconsPopupConstants.ICON_POPUP_MODE_IMAGES;
};
var popupBecameActive = function popupBecameActive(props, nextProps) {
    return nextProps.isActive && !props.isActive;
};

var shouldSearchForIcons = function shouldSearchForIcons(props, nextProps) {
    return (popupModeHasChanged(props, nextProps) || popupBecameActive(props, nextProps)) && !popupModeIsImages(nextProps) && !nextProps.iconList;
};

var IconPopup = (_dec = (0, _reactRedux.connect)(_iconPopupSelector2.default, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(IconPopup, _React$Component);

    function IconPopup() {
        _classCallCheck(this, IconPopup);

        return _possibleConstructorReturn(this, (IconPopup.__proto__ || Object.getPrototypeOf(IconPopup)).apply(this, arguments));
    }

    _createClass(IconPopup, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var searchForIcons = this.props.searchForIcons;


            if (!nextProps.isActive) return;

            // Don't search for icons if the popup mode is images
            if (shouldSearchForIcons(this.props, nextProps)) {
                searchForIcons({
                    query: nextProps.popupQuery,
                    id: nextProps.selectedElements.first().get('id')
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _PopupPanel2.default,
                { popupId: 'icon', arrowDir: _popupConstants.ARROW_DIR.left, className: 'iconPopup' },
                _react2.default.createElement(
                    'div',
                    { className: 'icon-popup-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mode-menu' },
                        _react2.default.createElement(_IconPopupModeList2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: 'tools' },
                            _react2.default.createElement(_IconPopupSearch2.default, this.props)
                        )
                    ),
                    _react2.default.createElement(_IconTabContent2.default, this.props)
                )
            );
        }
    }]);

    return IconPopup;
}(_react2.default.Component)) || _class);
exports.default = IconPopup;


IconPopup.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    isActive: _propTypes2.default.bool,
    selectedElements: _propTypes2.default.object,
    iconList: _propTypes2.default.object,
    popupMode: _propTypes2.default.string,
    modeList: _propTypes2.default.array,
    popupQuery: _propTypes2.default.string,
    searchForIcons: _propTypes2.default.func,
    setModeDefault: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/IconPopup.js
// module id = 2234
// module chunks = 0